module.exports = __webpack_public_path__ + "static/media/Groupshow-Airoplane.5e9acdbe.jpg";